import { JsonRpcProvider } from 'ethers';
import { chainNames, rpcUrls } from '../configs/rpc';
export const getProvider = (chainId) => {
    return new JsonRpcProvider(rpcUrls[chainId], {
        name: chainNames[chainId],
        chainId,
    }, {
        batchMaxCount: 10,
        batchStallTime: 100,
    });
};
